import CryptoJS from 'crypto-js'
import { v4 as uuidv4 } from 'uuid'
import { ElMessageBox } from 'element-plus'
import bcrypt from "bcryptjs"; // ✅ 正确方式
// 签名方法
export function sign(key, uuid, timestamp, secret) {
  const signStr = `key=${key}&uuid=${uuid}&timestamp=${timestamp}&Secret=${secret}&key=${key}`
  return CryptoJS.MD5(signStr).toString()
}

// 生成当前时间戳 (格式: yyyy-MM-dd HH:mm:ss)
export function getCurrentTimestamp() {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// 生成UUID
export function generateUUID() {
  return uuidv4()
}

// 生成BCrypt哈希
export async function generateHash(secret) {
  const salt = await bcrypt.genSalt(10)
  return await bcrypt.hash(secret, salt)
}


let secretPromptPromiseMap = new Map()

async function getSecret(key) {
  const user = localStorage.getItem('auth-user');

  console.log('user', user, user.appSecret)
  if (user) {
    const userInfo = JSON.parse(user);
    if (userInfo.appSecret) {
      return userInfo.appSecret;
    }
  }

  // 如果已存在等待中的弹窗，直接返回该 Promise，确保只弹一次
  if (secretPromptPromiseMap.has(key)) {
    return secretPromptPromiseMap.get(key)
  }

  // 创建一个新的弹窗 Promise
  const promptPromise = new Promise(async (resolve, reject) => {
    try {
      const { value } = await ElMessageBox.prompt(
        `请输入Key ${key} 对应的API Secret，获取方式请联系管理员！`,
        'Secret输入',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator: (value) => {
            if (!value) return 'Secret不能为空'
            return true
          }
        }
      )
      localStorage.setItem(secretKey, value)
      resolve(value)
    } catch (err) {
      reject(new Error('Secret is required'))
    } finally {
      // 不管成功失败都要清除挂起状态
      secretPromptPromiseMap.delete(key)
    }
  })

  // 缓存当前 key 的挂起弹窗 Promise
  secretPromptPromiseMap.set(key, promptPromise)

  return promptPromise
}

// 生成请求头
export async function generateHeaders(key) {
  try {
    const secret = await getSecret(key)
    if (!secret) {
      throw new Error('Secret is required')
    }
    const timestamp = getCurrentTimestamp()
    const uuid = generateUUID()
    const signature = sign(key, uuid, timestamp, secret)
    return {
      uuid,
      key,
      timestamp,
      sign: signature
    }
  } catch (error) {
    console.error('Error generating headers:', error)
    throw error
  }

}
export async function generateHeadersByKeyAndSecret(key, secret) {
  try {
    const timestamp = getCurrentTimestamp()
    const uuid = generateUUID()
    const signature = sign(key, uuid, timestamp, secret)
    return {
      uuid,
      key,
      timestamp,
      sign: signature
    }
  } catch (error) {
    console.error('Error generating headers:', error)
    throw error
  }
}

